import { BlogRootEntityTypes } from 'common/enums/blog-root-entity-types'
import ServerPageInterface from 'server/types/ServerPageInterface'
import { ParentIdEntityInterface } from 'src/shared/schemas/parent-id-schema'

export default function setParentIdSafeCommand(
  page: ServerPageInterface,
): [ServerPageInterface, boolean] {
  let needChangeContent = false
  const originalEntities = page.content.entities
  Object.values(originalEntities).forEach((entity, _, entities) => {
    // since we merge blog layout connect we might set parentId to BlogPageBody, but it leads to issue with breadcrumbs
    if (
      (!('parentId' in entity) || !entity.parentId) &&
      !BlogRootEntityTypes.includes(entity.type)
    ) {
      const parentEntity = entities.find(
        e => 'childIds' in e && e.childIds?.includes(entity.id),
      )
      if (parentEntity) {
        needChangeContent = true
        ;(originalEntities[entity.id] as ParentIdEntityInterface).parentId =
          parentEntity.id
      }
    }
  })

  return [page, needChangeContent]
}
